import React from 'react';
import Hero from '../components/Hero';
import Menu from '../components/Menu';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div data-testid="home-page">
      <Hero />
      <Menu />
      <Footer />
    </div>
  );
};

export default Home;
